module.exports = __webpack_public_path__ + "assets/5446e35090b3e7ea996c6a645cd65a61.svg";